import { useEffect, useMemo, useState } from 'react';

import type { IndeedProject } from 'shared/legacy/hooks/useBrowserExtension/indeed/useIndeedProjectListQuery';
import { useIndeedConfig } from 'shared/legacy/hooks/useBrowserExtension/indeed/useIndeedConfig';
import { useIndeedProjectListQuery } from 'shared/legacy/hooks/useBrowserExtension/indeed/useIndeedProjectListQuery';

export type IndeedBulkJobSelection = {
  selectedProject: IndeedProject | null;
  setSelectedProject: (project: IndeedProject | null) => void;
  creditBalance: number;
  isLoggedIn: boolean;
  isIndeedCreditsOutOfSync: boolean;
  hasNoCredits: boolean;
  isConfirmReady: boolean;
};

export function useIndeedBulkJobSelection(): IndeedBulkJobSelection {
  const [selectedProject, setSelectedProject] = useState<IndeedProject | null>(null);
  const indeedConfig = useIndeedConfig();
  const { data: projects = [] } = useIndeedProjectListQuery();

  useEffect(() => {
    if (selectedProject === null && projects.length > 0) {
      setSelectedProject(projects.find((p) => p.default) ?? projects[0]);
    }
  }, [selectedProject, projects]);

  const hasNoCredits =
    !indeedConfig.isInitialLoading && indeedConfig.creditBalance <= 0 && !indeedConfig.isIndeedCreditsOutOfSync;

  const isConfirmReady = useMemo(
    () => selectedProject !== null && indeedConfig.isLoggedIn && !hasNoCredits,
    [selectedProject, indeedConfig.isLoggedIn, hasNoCredits],
  );

  return {
    selectedProject,
    setSelectedProject,
    creditBalance: indeedConfig.creditBalance,
    isLoggedIn: indeedConfig.isLoggedIn,
    isIndeedCreditsOutOfSync: indeedConfig.isIndeedCreditsOutOfSync,
    hasNoCredits,
    isConfirmReady,
  };
}
